{
  "app": {
    "tittel": "Norgespris for fjernvarme",
    "language": "Språk",
    "language_nb-NO": "Bokmål",
    "language_nn-NO": "Nynorsk"
  },
  "button": {
    "login": "Logg inn",
    "logout": "Logg ut",
    "next": "Neste",
    "back": "Tilbake",
    "back-to-frontpage": "Gå til forsiden",
    "open": "Åpne",
    "vis-forklaring": "Vis forklaring for {{felt}}"
  },
  "components": {
    "nyttige-lenker": "Nyttige lenker"
  },
  "enums": {
    "boligType": "{{context}}",
    "boligType_Boliglag": "Boliglag",
    "boligType_Fritidsbolig": "Fritidsbolig",
    "boligType_Bolig": "Bolig",
    "boligType_Boligselskap": "Boligselskap",
    "boligType_Andre": "Andre bygg med husholdningsforbruk",
    "boligType_BoligselskapFritid": "Boligselskap med fritidsboliger",
    "jaNei": "{{context}}",
    "jaNei_ja": "Ja",
    "jaNei_nei": "Nei"
  },
  "eksterneLenker": {
    "forskriftOmNorgespris": {
      "url": "https://lovdata.no/dokument/SF/forskrift/2025-09-08-1792",
      "label": "Forskrift om Norgespris"
    },
    "lovOmNorgespris": {
      "url": "https://lovdata.no/dokument/NL/lov/2025-06-20-44",
      "label": "Lov om Norgespris og strømstønad til husholdninger"
    },
    "avtalevilkaar-og-avbestilling": {
      "url": "/vilkår",
      "label": "Avtalevilkår og avbestilling"
    },
    "merOmNorgespris": {
      "url": "https://www.nve.no/energi/energisystem/fjernvarme/norgespris-og-stroemstoette-for-fjernvarme/",
      "label": "Les mer om Norgespris"
    },
    "spmOgSvarNve": {
      "url": "https://www.nve.no/energi/energisystem/fjernvarme/norgespris-og-stroemstoette-for-fjernvarme/spoersmaal-og-svar-norgespris-og-stroemstoette-for-fjernvarme/",
      "label": "Spørsmål og svar til Norgespris og strømstøtte for fjernvarme"
    },
    "enovaSvarer": {
      "label": "Enova Svarer",
      "url": "https://www.enova.no/nb/om-oss/hvem-er-enova/kontakt-oss"
    },
    "nve": {
      "label": "www.nve.no",
      "url": "https://nve.no/"
    },
    "cookies": {
      "label": "Personvern og cookies",
      "url": "https://www.enova.no/nb/om-oss/hvem-er-enova/prinsipper-etterlevelse/datahandtering"
    },
    "tilgjengelighetserklæring": {
      "label": "Tilgjengelighetserklæring",
      "url": "https://uustatus.no/nb/erklaringer/publisert/afe7c36c-a37b-4093-be92-821468ae6c17"
    },
    "kundestotte": {
      "label": "Trenger du hjelp eller har spørsmål?",
      "url": "/kundestøtte"
    }
  },
  "feilmelding": {
    "overskrift": "Det oppstod en feil",
    "overskrift_404": "Fant ikke siden",
    "beskrivelse": "Vennligst prøv igjen ved et senere tidspunkt.",
    "beskrivelse_404": "Siden du prøvde å nå finnes ikke.\nKanskje har du skrevet inn en feil adresse, eller så er siden flyttet.",
    "beskrivelse_10001": "Vennligst prøv igjen ved et senere tidspunkt.",
    "prøv-igjen": "Prøv å last siden på nytt"
  },
  "pages": {
    "landing": {
      "ingress": "Norgespris er en ordning som er innført for å gi husholdninger og fritidsboliger forutsigbare priser på strøm og fjernvarme.",
      "button-bestill": "Bestill Norgespris",
      "ikke-aapnet-enda": {
        "tittel": "Bestilling av Norgespris åpner 24. september",
        "beskrivelse": "Fra 24. september kan du bestille Norgespris for fjernvarme ved å logge inn på denne siden. Les om ordningen på NVE sine nettsider.",
        "url-tittel": "Norgespris og strømstøtte for fjernvarme"
      },
      "paa-vegne-av": {
        "tittel": "Bestille for boligselskap eller andre kunder med husholdningsforbruk?",
        "beskrivelse": "For boligselskap, studentsamskipnad, kommunale boliger eller kombinasjonsbygg med husholdningsforbruk bak målepunktet må du ha tilgangsspakken <Uthevd>Tilskudd, Støtte og Erstatning</Uthevd>. Denne tilgangspakken tar over for rollene <Uthevd>Energi, miljø og klima</Uthevd> og <Uthevd>Utfyller/innsender</Uthevd> i Altinn. Roller vil ikke kunne tildeles etter 15.06.2026 men de som har rollene vil beholde sin tilgang via disse til 31.12.2026"
      },
      "mer-info": {
        "tittel": "Mer informasjon om Norgespris",
        "prisregulering": {
          "tittel": "Pris",
          "beskrivelse": "Prisen du betaler for fjernvarme består av flere deler. Velger du Norgespris for fjernvarme, vil den delen av fjernvarmeprisen som varierer med strømprisen være 50 øre/kWh inkludert mva. i hele prisperioden. I tillegg skal du betale de øvrige delene av fjernvarmeprisen som fremgår på fjernvarmeregningen, f.eks. avgifter, påslag, og administrasjonskostnader.  \n \nPrisen på 50 øre/kWh inkludert mva. Blir kalt referansepris. Den vil fra og med 2027, vedtas hvert år og kan dermed endre seg for senere prisperioder. "
        },
        "forbrukstak": {
          "tittel": "Forbrukstak",
          "beskrivelse": "For husholdningsforbruk er forbrukstaket 4 500 kWh per måned per energimåler. Dette gjelder både strømstønad og Norgespris.  \n\nFor fritidsboliger er forbrukstaket 1 000 kWh per måned per fritidsbolig. Dette gjelder for Norgespris. \n\nFor boligselskaper med fellesmålt fjernvarme er forbrukstaket 4 500 kWh per måned per boenhet, og 1 000 kWh per måned per boenhet for fritidsboliger.  \n\nFor fjernvarmekunder som bor fast i fritidsbolig og har egen energimåler registrert hos et fjernvarmeselskap med konsesjon eller nærvarmeselskap registrert hos NVE, er forbrukstaket 4 500 kWh per måned per energimåler.\n\nForbruk utover forbrukstaket får kunden ikke beregnet prissikringsbeløp for."
        },
        "norgespris": {
          "tittel": "Norgespris og strømstønad",
          "beskrivelse": "Norgespris er en egen avtale kunden inngår med fjernvarmeleverandøren sin, i tillegg til avtalen partene har inngått om fjernvarmeleveranse. Norgespris sikrer at kundene betaler 50 øre/kWh inkludert mva. for den delen av fjernvarmeprisen som varierer med strømprisen. Det betyr at når spotprisen på strøm er høyere enn 50 øre/kWh, betaler staten mellomlegget mellom 50 øre/kWh (Norgespris) og spotprisen. Er spotprisen på strøm lavere enn 50 øre/kWh, så betaler kunden fremdeles 50 øre/kWh.  \nI perioden kunden er bundet til Norgespris, vil du ikke kunne motta strømstønad.  \n \nDersom du ikke velger Norgespris, vil du motta strømstønad. Strømstønad på fjernvarme gir støtte på 90 % av månedlig gjennomsnitts spotpris over terskelverdien på 93,75 øre per kWh inkl. mva (75 øre/kWh uten mva). I tillegg består fjernvarmeprisen av kostnader for nettleie og avgift. Fritidsboliger har ikke rett på strømstønad.  \n \nHva du som kunde velger angående Norgespris eller strømstønad for fjernvarme, har ingen innvirkning på valget du kan gjøre angående Norgespris eller strømstønad på strøm. Det betyr at fjernvarmekunder kan velge f.eks. Norgespris på både fjernvarme og på strøm, eller f.eks. Norgespris på fjernvarme og strømstønad på strøm. Valget på strømsiden må gjøres via de måter nettselskapet eller strømselskapet ditt informerer deg om. "
        },
        "avtaleperiode": {
          "tittel": "Avtaleperiode og avbestilling",
          "beskrivelse": "Den første perioden med Norgespris skal gjelde fra 1. oktober 2025 til 31. desember 2026. Dette omtales som en prisperiode.  \n\nDu kan bestille Norgespris når som helst i løpet av prisperioden. Ved bestilling blir du bundet fra den 1. i påfølgende måned og ut året. Unntaket er 1. til 15. oktober, da bestillingen gjelder fra 1. oktober 2025.\n\nDu har 14 dagers avbestillingsrett fra dagen du bestiller Norgespris. Etter de 14 dagene er avtalen bindende frem til utgangen av prisperioden. For den første prisperioden betyr dette frem til 31. desember 2026. Det er ikke mulig å si opp avtalen om Norgespris eller bytte tilbake til den vanlige strømstønadsordningen før den aktuelle prisperioden er over.  \n\nDersom du selger boligen din, vil avtalen om Norgespris følge boligen. De nye eierne av boligen vil være bundet til prisperioden er over."
        },
        "gjelder": {
          "tittel": "Hvem gjelder Norgespris for?",
          "beskrivelse": "Norgespris gjelder for følgende kundegrupper: \n\n• Privatpersoner med husholdningsforbruk\n• Eiere av fritidsboliger\n• Boligselskaper\n• Kommunale boliger og studentsamskipnader\n• Kombinasjonsbygg med husholdningsforbruk bak måleren\n\nSe overskrifter under for å se hvilke selskap som er omfattet. Et fjernvarmeselskap kan ha nærvarmeanlegg som ikke er omfattet av ordningen."
        },
        "underlangt": {
          "tittel": "Hvem er underlagt ordningen?",
          "beskrivelse": "Alle fjernvarmeselskap med konsensjon etter energiloven skal tilby Norgespris. \nNoen fjernvarmeselskap bruker egen bestillingsløsning. Du vil få informasjon fra ditt fjernvarmeselskap om det gjelder deg.\n\nNærvarmeselskap omfattes ikke automatisk av krav om å tilby Norgespris. De nærvarmeselskapene som registerer seg hos NVE kan imidlertid tilby Norgespris. \n\nDu vil i bestillingsløsningen finne alle selskap som tilbyr Norgespris. Dersom du ikke finner selskapet ditt, er de ikke underlagt ordningen."
        }
      },
      "hjelpetekst-bilde": "Bilde som sympoliserer et nabolag med fjernvarme"
    },
    "velg-selskap": {
      "tittel": "Velg selskap",
      "beskrivelse": "Hvis du ønsker å administrere avtaler for et selskap, må du finne og velge selskapet i listen under. Vi vil da sjekke at du har riktig tilgangspakke i Altinn. For å kunne administrere bestillinger og rapportere målerdata på vegne av et fjernvarme/nærvarmeselskap, må man ha tilgangspakken <Uthevd>Tilskudd, Støtte og Erstatning</Uthevd>. Denne erstatter rollene <Uthevd>Energi, miljø og klima</Uthevd> og <Uthevd>Utfyller/innsender</Uthevd> i Altinn. Tilgangen du tidligere fikk via disse rollene vil fortsette å fungere til 31.12.2026, men de vil ikke kunne tildeles etter 15.06.2026",
      "form": {
        "label": "Velg selskap",
        "velg": "Logg inn",
        "autentiserer": "Sjekker at du har riktige tilganger til selskapet...",
        "autentiser-mislyktes": "Innlogging med organisasjonsnummer {{orgnr}} mislyktes. Sjekk at du har riktig tilgangspakke i Altinn.",
        "feil": {
          "pakrevd": "Du må velge et selskap for å fortsette.",
          "ingen-tilganger": "Ingen tilganger funnet for denne brukeren.",
          "laste-feil": "Det oppstod en feil ved lasting av selskaper. Vennligst prøv igjen senere."
        }
      }
    },
    "informasjon-om-norgespris": {
      "tittel": "Norgespris",
      "liste": {
        "tittel": "Liste over de viktigste delene av Norgespris.",
        "punkt-0": "Norgespris er en egen avtale du inngår med fjernvarmeleverandøren din. Denne gjelder i tillegg til avtalen om fjernvarmeleveranse du allerede har.",
        "punkt-1": "Om spotprisen på strøm er over 50 øre inkl. mva får du et fradrag på fjernvarmefakturaen din, men hvis spotprisen er lavere får du et tillegg. Fjernvarmefakturaen din vil også inkludere eventuelle påslag, avgifter og administrasjonskostnader.",
        "punkt-2": "Du er bundet fra første dag i påfølgende måned etter at du har bestilt Norgespris, til og med 31.12.2026.",
        "punkt-3": "Du kan avbestille Norgespris opptil 14 dager fra bestillingsdatoen. Etter dette er avtalen bindende til og med 31.12.2026.",
        "punkt-4": "Norgespris låses til energimåleren din. Dersom du selger boligen, vil de nye eierne få Norgespris ut avtaleperioden.",
        "punkt-5": "Norgespris gjelder opptil 4 500 kWh per måned per energimåler. Unntak: For boligselskaper gjelder forbrukstaket på 4 500 kWh per måned for hver boenhet. For fritidsboliger er forbrukstaket 1 000 kWh per måned.",
        "punkt-6": "Velger du Norgespris, vil du ikke få strømstønad i samme periode."
      }
    },
    "finn-leverandoer": {
      "tittel": "Finn leverandør",
      "beskrivelse": "For å kunne bestille Norgespris trenger vi å vite hvilken fjernvarmeleverandør du har avtale med.",
      "velg-leverandoer-label": "Velg eller søk på leverandør",
      "laster": "Henter leverandører...",
      "ingen-treff": "Ingen treff",
      "singular": "%d leverandør",
      "plural": "%d leverandører",
      "norgespris": {
        "tittel": "Norgespris hos {{navn}}"
      },
      "feil": {
        "leverandoerer": "Kunne ikke hente leverandører. Vennligst prøv igjen senere."
      },
      "form": {
        "leverandoer": {
          "paaakrevd": "Du må velge en leverandør for å fortsette.",
          "har-egen-løsning": "For bestilling av Norgespris må du gå til leverandøren sine egne nettsider og gjøre en bestilling. Gå til leverandøren sine nettsider. "
        }
      }
    },
    "aktoer": {
      "tittel": "Hvem bestiller du på vegne av?",
      "beskrivelse": "Som privatperson bestiller du kun for deg selv. \n\nDu kan bestille på vegne av boligselskap, studentsamskipnad, kommunale boliger eller kombinasjonsbygg med husholdningsforbruk bak målepunktet dersom du har riktig tilgangspakke i Altinn.",
      "altinnlenke": {
        "tittel": "Hvordan tildele tilgangspakke i Altinn",
        "url": "https://info.altinn.no/hjelp/ny-tilgangsstyring/tilgangspakker/via-menypunktet-fullmakter/"
      },
      "hvordan-tildele": "Hvordan tildele tilgangspakke i Altinn?",
      "finner-ikke-selskap": "Dersom du ikke finner selskapet ditt, må du først <Link>logge inn med selskapet her</Link>",
      "laster": "Henter aktører...",
      "ingen-treff": "Ingen treff",
      "singular": "%d aktør",
      "plural": "%d aktør",
      "feil": {
        "hent": "Kunne ikke hente aktører. Vennligst prøv igjen senere."
      },
      "form": {
        "felt": "{{context}}",
        "felt_aktoer": "Velg aktør",
        "aktoer": {
          "paaakrevd": "Du må velge en aktør for å fortsette.",
          "orgnr-ugyldig": "Organisasjonsnummeret er ugyldig."
        },
        "innsender": "Innsender"
      }
    },
    "periode": {
      "tittel": "Velg avtaleperiode",
      "beskrivelse": "Ved bestilling av Norgespris vil du bli bundet av avtalen fra den 1. i påfølgende måned. Det er gjort et unntak for perioden 1. til 15. oktober 2025, der du kan velge om avtalen skal gjelde fra 1. oktober 2025 eller 1. november 2025.\n\nVed bestilling blir du bundet ut 2026, med mindre du benytter deg av avbestillingsretten innenfor fristen.",
      "velg-periode-label": "Velg avtaleperiode",
      "feil": {
        "hent": "Kunne ikke hente avtaleperioder. Vennligst prøv igjen senere."
      },
      "form": {
        "paaakrevd": "Du må velge en periode for å fortsette.",
        "default-option": "Velg en periode"
      }
    },
    "bestiller": {
      "felles": {
        "kundenummer": "Kundenummer",
        "målerId": "Målerpunkt-ID",
        "adresse": "Adresse",
        "postnummer": "Postnummer",
        "poststed": "Poststed"
      },
      "privat": {
        "tittel": "Informasjon om boligen",
        "beskrivelse": "For å registrere boligen din for Norgespris, trenger vi informasjon du har registrert hos fjernvarmeleverandøren.",
        "form": {
          "felt": "{{context}}",
          "felt_boligType": "Type bolig",
          "felt_kundenummer": "Kundenummer",
          "felt_målerId": "Målerpunkt-ID",
          "felt_adresse": "Adresse",
          "felt_postnummer": "Postnummer",
          "felt_poststed": "Sted",
          "felt_vilkårAkseptert": "Vilkår akseptert",
          "hjelpetekst": "{{context}}",
          "hjelpetekst_kundenummer": "Kundenummeret finner du på fakturaen fra din fjernvarmeleverandør.",
          "hjelpetekst_målerId": "Målepunkt-ID finner du vanligvis på fjernvarmefakturaen din. Hvis du ikke finner målepunkt-ID på fakturaen din, kan du fylle inn målernummer. Har fakturaen din ingen av delene, lar du feltet stå tomt.",
          "feil": {
            "boligType": {
              "påkrevd": "Du må velge en boligtype."
            },
            "målerId": {
              "påkrevd": "Målerpunkt-ID kan ikke være tom."
            },
            "kundenummer": {
              "påkrevd": "Kundenummer kan ikke være tom."
            },
            "adresse": {
              "påkrevd": "Adresse kan ikke være tom."
            },
            "postnummer": {
              "ugyldig": "Postnummer må være 4 siffer."
            },
            "poststed": {
              "påkrevd": "Sted kan ikke være tomt."
            },
            "vilkårAkseptert": {
              "påkrevd": "Du må godta vilkårene for å fortsette."
            }
          }
        }
      },
      "selskap": {
        "tittel": "Informasjon om bestilleren",
        "beskrivelse": "For å bestille Norgespris for boligselskap eller andre bygg med husholdningsforbruk, trenger vi informasjon dere har registert hos fjernvarmeleverandør.",
        "form": {
          "felt": "{{context}}",
          "felt_kundenummer": "Kundenummer",
          "felt_målerId": "Målerpunkt-ID",
          "felt_antallBoenheter": "Antall boenheter",
          "felt_næringsdrivende": "Er det næringsareal i boligselskapet?",
          "felt_næringsarealProsent": "Andel næringsareal i prosent",
          "felt_boligType": "Type organisasjon",
          "hjelpetekst": "{{context}}",
          "hjelpetekst_kundenummer": "Kundenummeret finner du på fakturaen fra din fjernvarmeleverandør.",
          "hjelpetekst_målerId": "Målepunkt-ID finner du vanligvis på fjernvarmefakturaen din. Hvis du ikke finner målepunkt-ID på fakturaen din, kan du fylle inn målernummer. Har fakturaen din ingen av delene, lar du feltet stå tomt.",
          "hjelpetekst_næringsarealProsent": "Oppgir andel næringsareal i prosent av totalt oppvarmet areal.\nOppvarmet næringsareal (kvm) / totalt oppvarmet areal i bygget (kvm) * 100 = andel næringsareal i prosent. ",
          "boligType": {
            "tittel_Boligselskap": "Boligselskap",
            "beskrivelse_Boligselskap": "F.eks. borettslag eller sameier som i tillegg kan ha tilknyttet næringsareal.",
            "tittel_BoligselskapFritid": "Boligselskap med fritidsboliger",
            "beskrivelse_BoligselskapFritid": "For boligselskaper som har fritidsboliger tilknyttet fjernvarme.",
            "tittel_Andre": "Andre bygg med husholdningsforbruk",
            "beskrivelse_Andre": "F.eks. kjøpesenter eller kontorbygg som har tilknyttede boliger."
          },
          "feil": {
            "målerId": {
              "påkrevd": "Målerpunkt-ID kan ikke være tom."
            },
            "kundenummer": {
              "påkrevd": "Kundenummer kan ikke være tom."
            },
            "antallBoenheter": {
              "positiv": "Antall boenheter må minst være 1."
            },
            "næringsdrivende": {
              "påkrevd": "Du må velge om det er næringsareal i boligselskapet."
            },
            "næringsarealProsent": {
              "paakrevd": "Næringsareal prosent må fylles ut.",
              "minMax": "Næringsareal prosent må være et tall fra 1 til og med 100.",
              "maks-to-desimaler": "Bare tall mellom 1 og 100 er gyldig. Rund av til nærmeste to desimaler."
            },
            "boligType": {
              "påkrevd": "Du må velge en type organisasjon."
            }
          }
        }
      },
      "felt-paakrevd": "Alle felt er påkrevd."
    },
    "oppsummering": {
      "tittel": "Oppsummering",
      "beskrivelse": "Kontroller opplysningene og bekreft vilkårene for Norgespris for å fullføre bestillingen.",
      "felt": {
        "leverandør": {
          "tittel": "Leverandør",
          "navn": "Navn"
        },
        "aktør": {
          "tittel": "Bestiller",
          "navn": "Navn",
          "innsender": "Innsender"
        },
        "avtaleperiode": {
          "tittel": "Avtaleperiode",
          "dato": "Dato"
        },
        "privat": {
          "tittel": "Informasjon om boligen",
          "boligType": "Type bolig",
          "kundenummer": "Kundenummer",
          "målerId": "Målerpunkt-ID",
          "adresse": "Adresse"
        },
        "selskap": {
          "tittel": "Informasjon om bestilleren",
          "kundenummer": "Kundenummer",
          "målerId": "Målerpunkt-ID",
          "antallBoenheter": "Antall boenheter",
          "næringsdrivende": "Har næringsareal",
          "næringsarealProsent": "Andel næringsareal i prosent",
          "boligType": "Type organisasjon",
          "ja": "Ja",
          "nei": "Nei"
        },
        "vilkårAkseptert": {
          "tittel": "Aksepter vilkårene",
          "checkbox-label": "Jeg har lest og aksepterer vilkårene for Norgespris.",
          "les-vilkår": "Les vilkårene for Norgespris",
          "vilkår-må-aksepteres": "Du må godta vilkårene for å gjennomføre bestillingen."
        }
      },
      "laster": "Henter...",
      "endre": "Endre",
      "gå-til-endre": "Gå til {{navn}} siden for å endre opplysningene under",
      "ikke-utfylt": "Ikke utfylt",
      "send-inn": "Send inn bestilling",
      "toast": {
        "suksess": "Du er nå registrert for Norgespris for fjernvarme!",
        "feil": "Det oppstod en feil ved innsending av bestillingen. Se om alle feltene er riktig utfylt, og prøv igjen.",
        "feil_409": "Bestillingen eksisterer allerede fra før. Vennligst sjekk opplysningene og prøv igjen."
      },
      "dialog": {
        "oppretter-bestilling": "Oppretter bestilling..."
      },
      "bestillingsdato": "Bestillingsdato",
      "personopplysninger": {
        "beskrivelse-lenke": "Forskrift om Norgespris og strømstønad til husholdninger som bruker fjernvarme § 31.",
        "beskrivelse": "Energidepartementet har gitt Enova ansvaret for å utbetale og kreve inn støtte- og prissikringsbeløp knyttet til fjernvarme. NVE skal føre tilsyn og kontroll med ordningen.\n\nDette innebærer at Enova og NVE må samle inn og behandle personopplysninger som er nødvendig for å ivareta sine lovfestede plikter. Plikten følger av ",
        "tittel": "Behandling av personopplysninger"
      }
    },
    "bekreftelse": {
      "feil": {
        "hent": "Kunne ikke hente bestilling. Vennligst prøv igjen senere"
      },
      "header": {
        "tittel": "Bestillingsbekreftelse",
        "beskrivelse": "Takk! Vi har mottatt din bestilling på Norgespris."
      },
      "avtale": {
        "selskap": {
          "leverandør": {
            "tittel": "Leverandør",
            "navn": "Navn"
          },
          "aktør": {
            "tittel": "Bestiller",
            "navn": "Navn",
            "organisasjonsnummer": "Organisasjonsnummer",
            "innsender": "Innsender"
          },
          "avtaleperiode": {
            "tittel": "Avtaleperiode",
            "dato": "Dato"
          },
          "informasjon-om-boligselskap": {
            "tittel": "Informasjon om bestilleren",
            "type-bolig": "Type bolig",
            "type-bolig-boligselskap": "Boligselskap",
            "type-organisasjon": "Type organisasjon",
            "kundenummer": "Kundenummer",
            "måler-id": "Målerpunkt-ID",
            "antall-boenheter": "Antall boenheter",
            "næringsareal": "Næringsareal",
            "andel-næringsareal": "Andel næringsareal",
            "næringsdrivende": "Har næringsareal"
          }
        },
        "privat": {
          "leverandør": {
            "tittel": "Leverandør",
            "navn": "Navn"
          },
          "aktør": {
            "tittel": "Bestiller",
            "innsender": "Innsender"
          },
          "avtaleperiode": {
            "tittel": "Avtaleperiode",
            "dato": "Dato"
          },
          "informasjon-om-bolig": {
            "tittel": "Informasjon om bolig",
            "type-bolig": "Type bolig",
            "kundenummer": "Kundenummer",
            "måler-id": "Målerpunkt-ID",
            "adresse": "Adresse"
          }
        }
      },
      "tidspunkt": {
        "opprettet": "Avtale opprettet",
        "endret": "Avtale sist endret",
        "avbestilt": "Avtale avbestilt"
      },
      "informasjon": {
        "pris-tittel": "Pris",
        "bindingstid-avbestill-tittel": "Bindingstid og avbestilling",
        "avbestill-tittel": "Avbestilling",
        "avbestill-beskrivelse": "Du har 14 dagers avbestillingsrett fra du bestilte Norgespris. Etter de 14 dagene, er avtalen bindende frem til 31. desember 2026. Det er ikke mulig å si opp avtalen eller bytte tilbake til den vanlige strømstønadsordningen før bindingstiden løper ut. Hvis du selger boligen din, vil avtalen om Norgespris følge boligen og overføres til den nye eieren. ",
        "kontakt": {
          "spm-om-norgespris-tittel": "Spørsmål om Norgespris?",
          "faa-hjelp": "Ta kontakt med kundestøtte"
        }
      },
      "actions": {
        "knapp-navigasjon": "Gå til forsiden"
      },
      "ikke-aktiv": "Avtalen er ikke lengre aktiv.\n\nAvtalen gjaldt originalt for perioden: {{periode}}"
    },
    "endre": {
      "tittel": "Endre bestilling",
      "beskrivesle": "Du kan korrigere bestillingen frem til avbestillingsfristen den {{context}}.",
      "form": {
        "feil": {
          "feil-lasting": "Det har oppstått en feil, prøv igjen senere",
          "feil-posting-tittel": "Endring feilet",
          "feil-posting-beskrivelse": "Det oppstod en feil ved endring av bestillingen. Se om alle feltene er riktig utfylt, og prøv igjen."
        },
        "suksess": {
          "suksess-tittel": "Dine endringer er lagret."
        },
        "leverandør": {
          "tittel": "Leverandør",
          "navn": "Navn"
        },
        "aktør": {
          "tittel": "Bestiller",
          "navn": "Navn",
          "organisasjonsnummer": "Organisasjonsnummer",
          "innsender": "Innsender"
        },
        "avtaleperiode": {
          "tittel": "Avtaleperiode",
          "dato": "Dato"
        }
      },
      "knapper": {
        "lagre": "Lagre endringer",
        "avbryt": "Avbryt"
      }
    },
    "avtaler": {
      "statuser": {
        "avtaleStatus": "{{context}}",
        "avtaleStatus_Aktiv": "Aktiv",
        "avtaleStatus_Avbestilt": "Avbestilt",
        "avtaleStatus_Utgått": "Utgått",
        "avtaleStatus_Ugyldig": "Avtale kansellert",
        "ugyldigAvtaleÅrsak": "{{context}}",
        "ugyldigAvtaleÅrsak_Annet": "Annet",
        "ugyldigAvtaleÅrsak_IngenKundeForhold": "Ingen kundeforhold"
      },
      "avbestilling": {
        "tittel": "Avbestilling av Norgespris",
        "beskrivelse": "Ved å avbestille Norgespris innen avbestillingsfristen på 14 dager, vil du gå tilbake til ordningen med strømstønad, med unntak av fritidsboligkunder.",
        "feil-lasting": "Det har oppstått en feil, prøv igjen senere",
        "leverandør-tittel": "Leverandør",
        "leverandør-navn": "Navn",
        "bestiller-tittel": "Bestiller",
        "avtaleperiode-tittel": "Avtaleperiode",
        "avtaleperiode-dato": "Dato",
        "innsender": "Innsender",
        "informasjon-privat-tittel": "Informasjon om bolig",
        "informasjon-selskap-tittel": "Informasjon om bestilleren",
        "bekreft-avbestilling-tittel": "Bekreft avbestilling",
        "bekreft-avbestilling-checkbox": "Jeg bekrefter at jeg ønsker å avbestille Norgespris",
        "feil-bekreft-avbestilling-tittel": "For å avbestille må du sørge for følgende",
        "feil-bekreft-avbestilling": "Bekreft avbestilling",
        "knapp-avbryt": "Avbryt",
        "knapp-avbestill": "Avbestill Norgespris",
        "alert-vellykket-tittel": "Avbestilling vellykket!",
        "alert-vellykket-beskrivelse": "Vi har mottatt din avbestilling",
        "alert-feilet-tittel": "Avbestilling feilet",
        "alert-feilet-beskrivelse": "Det oppstod en feil under avbestillingen. Vennligst prøv igjen.",
        "alert-utløpt-tittel": "Avtale utløpt",
        "alert-utløpt-beskrivelse": "Avtalen utløp den",
        "alert-frist-utløpt-tittel": "Avbestillingsfristen er utløpt.",
        "alert-first-utløpt-beskrivelse": "Du er bundet til avtalen om Norgespris frem til"
      },
      "avtaler": {
        "tittel": "Avtaler",
        "beskrivelse": "Her finner du dine avtaler om Norgespris.",
        "ingen-aktive-avtaler": "Ingen aktive bestillinger.",
        "bestill-norgespris": "Bestill Norgespris",
        "ingen-bestillinger": "Du har ingen bestillinger. Hvis avbestillingsperioden er over, vil bestillingen ligge under avtaler.",
        "legg-til-ny-bestillinger": "Legg til ny bestilling",
        "detaljer": {
          "avbestilt": "Avbestilt",
          "avtaleperiode": "Avtaleperiode",
          "typeBolig": "Type bolig",
          "kundeNummer": "Kundenummer",
          "målerId": "Målerpunkt-ID",
          "adresse": "Adresse",
          "organisasjonsNummer": "Organisasjonsnummer",
          "avbestilling": "Kan avbestilles frem til",
          "bestiller-epost": "E-post",
          "bestiller-navn": "Navn",
          "antallBoenheter": "Antall boenheter",
          "næringsdrivende": "Næringsareal",
          "næringsareal": "Andel næringsareal",
          "organisasjonType": "Type organisasjon"
        },
        "valg": {
          "tittel": "Valg",
          "endre": "Endre",
          "vis-kvittering": "Vis ordrebekreftelse",
          "avbestill": "Avbestill"
        },
        "ugyldig-avtale": {
          "beskrivelse": "Avtalen er kansellert av leverandøren.",
          "årsak": "Årsak: {{context}}",
          "melding-fra-leverandør": "Melding fra {{context}}:",
          "default-melding": "Ta kontakt med {{context}} for mer informasjon."
        }
      },
      "header": {
        "tittel": "Hei, {{navn}}",
        "beskrivelse-med-selskap": "Du er for øyeblikket logget inn med <Uthevd>{{selskapsNavn}}</Uthevd>, og vil kunne administrere selskapets avtaler i tillegg til dine egne. \n Hvis du ønsker å bytte selskap, kan du gjøre det ved å klikke på knappen til høyre.",
        "beskrivelse-uten-selskap": "Hvis du ønsker å administrere avtaler for et selskap, kan du gjøre det ved å klikke på knappen til høyre.",
        "bytt-selskap-knapp": "Velg selskap"
      }
    },
    "kundestotte": {
      "tittel": "Kundestøtte",
      "spoersmaal-om-fjernvarme": {
        "tittel": "Spørsmål om fjernvarme",
        "beskrivelse": "Har du spørsmål om avtale, faktura eller generelt om fjernvarme, ta kontakt med din fjernvarmeleverandør."
      },
      "spoersmaal-om-regelverk": {
        "tittel": "Spørsmål om regelverket for Norgespris",
        "beskrivelse": "Har du spørsmål eller trenger mer informasjon om Norgespris og strømstøtte for fjernvarme. Kan du finne svar på NVE (Norges vassdrags- og energidirektorat) sine nettsider.",
        "lenke-mer-om-regelverket": "NVE - Spørsmål og svar til Norgespris og strømstøtte for fjernvarme",
        "lenke-om-norgespris": "NVE - Norgespris og strømstøtte for fjernvarme"
      },
      "spoersmaal-om-loesning": {
        "tittel": "Spørsmål til bestillingsløsningen",
        "beskrivelse": "Har du tekniske spørsmål om bestillingsløsningen for Norgespris, kan du ta kontakt med Enova Svarer.",
        "lenke-kontakt-oss": "Enova - Kontakt oss"
      },
      "fjernvarmeleverandoer": {
        "tittel": "Fjernvarmeleverandør",
        "beskrivelse": "Som fjernvarmeleverandør kan du finne mer informasjon og avtaler for dine kunder i selskapsportalen.",
        "lenke-kontakt-oss": "Selskapsportalen for fjernvarmeleverandører"
      }
    }
  },
  "skjema": {
    "navigering": {
      "kan-lagre": {
        "tittel": "Vil du lagre endringene?",
        "beskrivelse": "Du har gjort endringer som ikke er lagret. Ønsker du å lagre før du går videre?",
        "lagre": "Ja, lagre",
        "ikke-lagre": "Nei, ikke lagre"
      },
      "kan-ikke-lagre": {
        "tittel": "Ulagrede endringer",
        "beskrivelse": "Skjemaet inneholder ugyldige data. Du må rette opp i feilene før du kan lagre.",
        "videre": "Gå videre uten å lagre",
        "avbryt": "Avbryt og rett opp feil"
      },
      "next-button-disabled": "Kan ikke gå til neste steg før alle feltene over er fylt ut korrekt."
    },
    "feil-oppsummering": "For å gå videre må du rette opp følgende feil",
    "stepper": "Steg {{steg}} av {{total}}",
    "feil-ved-henting": "Det oppsto en feil ved henting av skjema",
    "laster": "Henter skjema..."
  },
  "password-protection": {
    "tittel": "Passordbeskyttelse",
    "beskrivelse": "Innlogging er bare åpnet for personer som skal teste løsningen. Gå tilbake til forsiden for å lese mer om når Norgespris for fjernvarme blir tilgjenglig for alle.",
    "tilbake": "Tilbake til forsiden",
    "passord": {
      "label": "Passord",
      "placeholder": "Skriv inn passord"
    },
    "feil": {
      "ugyldig-passord": "Ugyldig passord. Vennligst prøv igjen.",
      "passord-pakrevd": "Passord er påkrevd for å fortsette."
    }
  },
  "toaster": {
    "lukk": "Lukk varsel"
  },
  "callback": {
    "logger-inn": "Logger inn",
    "venter": "Vennligst vent mens vi fullfører innloggingen."
  }
}
